import m from "mithril";

export class Snowflakes {
  view() {
    return(
        <div key="snowflakes" class="snowflakes" aria-hidden>
          <div key="snowflake-1" class="snowflake">❅</div>
          <div key="snowflake-2" class="snowflake">❅</div>
          <div key="snowflake-3" class="snowflake">❅</div>
          <div key="snowflake-4" class="snowflake">❅</div>
          <div key="snowflake-5" class="snowflake">❅</div>
          <div key="snowflake-6" class="snowflake">❅</div>
          <div key="snowflake-7" class="snowflake">❅</div>
          <div key="snowflake-8" class="snowflake">❅</div>
          <div key="snowflake-9" class="snowflake">❅</div>
          <div key="snowflake-10" class="snowflake">❅</div>
          <div key="snowflake-11" class="snowflake">❅</div>
          <div key="snowflake-12" class="snowflake">❅</div>
        </div>
    );
  }
}
